import React from 'react'
import CustomTable from '../../shared/CustomTable'
function PayerTable () {
  return (
    <div>
      <CustomTable
        headers={[
          'Payer ID',
          'Payer Name',
          'TPA',
          'TPA Report',
          'Effective Date',
          'End Date'
        ]}
        // rows={[{ Name: 'John Doe', Age: 28, Location: 'New York' }]}
      />
    </div>
  )
}

export default PayerTable
